import React from 'react';
import { BsArrowLeftSquare } from 'react-icons/bs';
import { locales } from '../../../translations/locales';

const ButtonReturnMod = (props) => {
    const { theme, loadGame, locale } = props;
    return (
        <div
            className={`buttonReturnMod m-1 cursor-pointer menu-nav menu-nav-${theme === 'DARK' ? 'dark' : 'light'}`}
            onClick={() => loadGame()}
        >
            <BsArrowLeftSquare className='mb-1' /> {locales[locale].config.btnBack}
        </div>
    );
};

export default ButtonReturnMod;
